import {
  HOME_TYPE,
  WORK_TYPE,
  OTHER_TYPE
} from 'components/common/constants/addressTypesConstants';

export const addressDataHelper = (type) => {
  switch (type) {
    case HOME_TYPE:
      return { icon: 'home', label: 'Home' };
    case WORK_TYPE:
      return { icon: 'briefcase', label: 'Work' };
    default:
      return { icon: 'star', label: 'Other' };
  }
}
